import { render } from "./XIcon.vue?vue&type=template&id=7c1525e2&ts=true"
import script from "./XIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./XIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/XIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c1525e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c1525e2', __exports__)) {
    api.reload('7c1525e2', __exports__)
  }
  
  module.hot.accept("./XIcon.vue?vue&type=template&id=7c1525e2&ts=true", () => {
    api.rerender('7c1525e2', render)
  })

}


export default __exports__